import classNames from 'classnames';
import { FunctionComponent } from 'react';

interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  variant?: 'primary' | 'secondary-blue' | 'secondary-black';
  currentColor?: boolean;
}

const Button: FunctionComponent<ButtonProps> = ({
  currentColor = false,
  variant = 'primary',
  className,
  ...buttonProps
}) => {
  return (
    <button
      className={classNames(
        className,
        'text-sm leading-5 rounded-full block font-bold transform transition active:scale-95 text-center uppercase py-4 px-6 cursor-pointer select-none',
        {
          'bg-theme-main hover:bg-theme-hover-main text-theme-white':
            variant === 'primary',
          'border-theme-main border text-theme-main hover:bg-theme-main/10 bg-white':
            variant === 'secondary-blue',
          'border-black border text-black hover:bg-[#EFEFEF] bg-white':
            variant === 'secondary-black',
        },
      )}
      {...buttonProps}
    ></button>
  );
};

export default Button;
